import * as Actions from "./Actions";
import { handleAction } from "redux-actions";

const defaultState = ({
    payload: {},
    meta: {
        fetch: false,
        status: ""
    }
});

const defaultReducer = {
    next: (_,action) => {
        console.log({...action});
        return {...action}
    },
    throw: (_,action) => {
        return (Object.assign(action, {
            meta: {
                fetch: false,
                status: Actions.statusEnum.FAILURE
            }
        }))
    }
};



export const loginConnection = handleAction(
    Actions.http.connection.authentication.login,
    defaultReducer,
    defaultState
);
export const logoutConnection = handleAction(
    Actions.http.connection.authentication.logout,
    defaultReducer,
    defaultState
);



const defaultAuthState = ({
    payload: {
        is_checked: true,
        ia_authenticated: false
    }
});

export const session = handleAction(
    Actions.data.session,
    (_,action) => {
        return action
    },
    defaultAuthState
);
